import cryptoSha1 from 'crypto-js/md5'
import hex from 'crypto-js/enc-hex'

const sha1 = (data: string): string => cryptoSha1(data).toString(hex)
export default sha1
